import React, { useEffect, useState } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import { apiService } from '../services/apiService';

const typeColor = {
  announcement: '#1976D2',
  attendance:   '#388E3C',
  grade:        '#F57C00',
  message:      '#7B1FA2',
  general:      '#546E7A',
};

const Notifications = () => {
  const [items, setItems]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');

  const load = async () => {
    try {
      setLoading(true);
      const data = await apiService.get('notifications');
      setItems(Array.isArray(data) ? data : []);
    } catch { setError('Failed to load notifications.'); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const markAllRead = async () => {
    try {
      await apiService.put('notifications/read-all', {});
      setItems(prev => prev.map(n => ({ ...n, is_read: 1 })));
    } catch (_) {}
  };

  const markRead = async id => {
    try {
      await apiService.put(`notifications/${id}/read`, {});
      setItems(prev => prev.map(n => n.id === id ? { ...n, is_read: 1 } : n));
    } catch (_) {}
  };

  const unread = items.filter(n => !n.is_read).length;

  if (loading) return <LoadingSpinner message="Loading notifications..." />;

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Notifications {unread > 0 && <span style={{ fontSize: '1rem', background: '#D32F2F', color: '#fff', borderRadius: 12, padding: '0.1rem 0.6rem', marginLeft: '0.5rem' }}>{unread}</span>}</h1>
        {unread > 0 && (
          <button className="btn btn-secondary" onClick={markAllRead}>Mark all as read</button>
        )}
      </div>

      {error && <div className="error-message">{error}</div>}

      {items.length === 0 ? (
        <div className="no-data-message">No notifications yet.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          {items.map(n => (
            <div
              key={n.id}
              onClick={() => !n.is_read && markRead(n.id)}
              style={{
                background:  n.is_read ? 'var(--card-bg)' : 'var(--card-bg)',
                border:      `1px solid ${n.is_read ? 'var(--border-color)' : typeColor[n.type] || '#546E7A'}`,
                borderLeft:  `4px solid ${typeColor[n.type] || '#546E7A'}`,
                borderRadius: 8,
                padding:     '1rem 1.25rem',
                cursor:      n.is_read ? 'default' : 'pointer',
                opacity:     n.is_read ? 0.75 : 1,
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.3rem' }}>
                    {!n.is_read && <span style={{ width: 8, height: 8, borderRadius: '50%', background: typeColor[n.type] || '#546E7A', display: 'inline-block', flexShrink: 0 }} />}
                    <strong>{n.title}</strong>
                    <span style={{ fontSize: '0.75rem', background: `${typeColor[n.type] || '#546E7A'}22`, color: typeColor[n.type] || '#546E7A', padding: '0.1rem 0.4rem', borderRadius: 4 }}>
                      {n.type}
                    </span>
                  </div>
                  <p style={{ margin: 0, color: 'var(--text-light)', fontSize: '0.9rem' }}>{n.message}</p>
                </div>
                <span style={{ fontSize: '0.78rem', color: 'var(--text-light)', flexShrink: 0, marginLeft: '1rem' }}>
                  {new Date(n.created_at).toLocaleString()}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Notifications;
